import { render, staticRenderFns } from "./content-string-selector.vue?vue&type=template&id=5b8886ac"
import script from "./content-string-selector.vue?vue&type=script&lang=js"
export * from "./content-string-selector.vue?vue&type=script&lang=js"
import style0 from "./content-string-selector.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/content/string/content-string-selector.vue
// module id = OLOz
// module chunks = 0